class VideoNative {
  constructor() {
    const playButton = Array.from(document.querySelectorAll('.lc-video--native .lc-video__thumbnail'));
    console.log(playButton);
    playButton.forEach(button => {
      button.addEventListener('click', () => {
        const videoNative = button.parentElement.parentElement;
        const thumbnail = button;
        const videoNativeContainer = videoNative.querySelector('.lc-video--native');
        const link = button.parentElement.nextSibling;
        const videoNativeElement = videoNative.querySelector('video');

        if (videoNativeElement) {
          videoNativeElement.play();
        }

        button.style.display = 'none';
        thumbnail.style.display = 'none';
        videoNativeContainer.style.display = 'block';
        if (link) {
          link.style.display = 'none';
        }
      });
    });
  }

} export default VideoNative;
